const widgetDefaultParams = [
  { name: 'PaginatedArticleListWidget', param: 'page', default: 1 }
]

export default widgetDefaultParams
